/** Cycle 7 — step-up (fresh authenticator code) token cache + modal bridge.
 * Sensitive endpoints return 428 STEP_UP_REQUIRED; the api interceptor calls
 * requestStepUp() which opens the global modal (StepUpHost), obtains a short-lived
 * step-up JWT and retries the original request.
 */
let cached = null; // { token, exp }
let opener = null; // set by StepUpHost when mounted
let pending = null;

export const getStepUpToken = () => (cached && cached.exp > Date.now() ? cached.token : null);

export const setStepUpToken = (token, ttlSec = 270) => {
  cached = { token, exp: Date.now() + ttlSec * 1000 };
};

export const clearStepUp = () => {
  cached = null;
};

export const registerStepUpOpener = (fn) => {
  opener = fn;
};

export const requestStepUp = () => {
  const t = getStepUpToken();
  if (t) return Promise.resolve(t);
  if (pending) return pending;
  if (!opener) return Promise.reject(new Error("This action needs a fresh authenticator code — sign in on the staff portal."));
  pending = new Promise((resolve, reject) => opener(resolve, reject)).finally(() => {
    pending = null;
  });
  return pending;
};
